import React, { useEffect, useState } from 'react';
import ReactTable from '../../components/shared/ReactTable';
import { COLUMNS } from '../../constants/tableColumns';
import Modal from '../../components/shared/Modal';
import IndependantRepHistoryModal from './IndependantRepHistoryModal';
import { NoContent } from '../../components/shared';
import LoadingSpinner from '../../components/LoadingSpinner';

export default function IndependantRepTable({
  apidata,
  isSuccess,
  isLoading,
  isError,
  isFetching,
  currentPage,
  perPageNumber,
  totalCount,
  pageChangeHandler,
  perPageChangeHandler,
}) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedSublocation, setSelectedSublocation] = useState(null);
  const [tableData, setTableData] = useState([]);

  // Process the API data when it changes
  useEffect(() => {
    if (isSuccess && apidata) {
      const users = apidata?.data?.locationUsersHistory?.map((history) => ({
        sublocationName: history?.sublocation?.name,
        sublocationId: history?.sublocation?.id,
        independantRep: history?.user?.firstName + ' ' + history?.user?.lastName,
        pay: history?.pay || '',
      }));
      setTableData(users);
    } else if (isError) {
      setTableData([]);
    }
  }, [isSuccess, isError, apidata]);

  const rowClassName = () => 'clickableRow';

  const modifiedTableData = tableData?.map((row) => ({
    ...row,
    onClick: () => handleSublocationClick(row),
  }));

  const closeModal = () => {
    setModalOpen(false);
    setSelectedSublocation(null);
  };

  const handleSublocationClick = (row) => {
    setSelectedSublocation(row);
    setModalOpen(true);
  };

  return (
    <>
      {(isLoading || isFetching) && <LoadingSpinner containerHeight={300} />}
      {!isLoading && !isError && !isFetching && tableData && tableData?.length > 0 ? (
        <ReactTable
          data={modifiedTableData}
          columns={COLUMNS.INDEPENDENT_REP}
          pagination
          manualPagination
          totalCount={totalCount}
          pageNumberForTablePagination={currentPage - 1}
          onPageChange={pageChangeHandler}
          onPerPageChange={perPageChangeHandler}
          perPage={perPageNumber}
          renderRows
          enableRowClick={true}
          getTrProps={() => ({
            className: rowClassName(),
          })}
        />
      ) : (
        !isLoading && !isFetching && <NoContent title="No Independent Rep found" desc={<>No results found.</>} />
      )}
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          onClose={closeModal}
          title={`Independent Rep pay for ${selectedSublocation.sublocationName}`}
          titleVariant="subtitle10"
          closeIcon={true}
          PaperProps={{
            sx: {
              width: '75%',
              maxWidth: 'none',

              maxHeight: '60%',
              height: '70%', // disable built-in maxWidth
              overflow: 'hidden',
            },
          }}
        >
          <IndependantRepHistoryModal selectedSublocation={selectedSublocation} />
        </Modal>
      )}
    </>
  );
}
